import { useHistory } from 'react-router';
import { Button, Form, Input, message } from 'antd';
import api from '@/api';
import HttpStatus from 'http-status-codes';
import { ErrorMessage } from '@/constants/message';
import { useAppDispatch } from '@/store';
import { getMe } from '@/features/account/accountSlice';
import { PATH_MAIN } from '@/constants/constant';

const CompanyRegistrationPage = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log(values);
    api.post('/company', 'pcompany.PbCompanyCreateRequest', { company: { name: values.name, no: values.no } }).then(() => {
      message.success('가입 신청이 완료되었습니다.');
      dispatch(getMe());
      history.push(PATH_MAIN);
    });
  };

  return (
    <>
      <div className="text-lg">회사 조회 및 등록 페이지</div>
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} onFinish={onFinish}>
        <Form.Item name="name" label="회사명" rules={[{ required: true, message: '회사명을 입력하세요.' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="no"
          label="법인번호"
          rules={[
            { required: true, message: '법인번호를 입력하세요.' },
            ({ getFieldError, setFields }) => ({
              validator: async (rule, value, callback) => {
                if (value && getFieldError('no').length === 0) {
                  setFields([{ name: 'no', validating: true }]);
                  api
                    .post('/company/check', 'pcompany.PbCompanyCheckRequest', { type: 'no', value })
                    .then(() => callback())
                    .catch((e) => {
                      setFields([{ name: 'no', validating: false }]);
                      switch (e.response.status) {
                        case HttpStatus.CONFLICT:
                          setFields([{ name: 'no', errors: [ErrorMessage.auth.email.already] }]);
                          break;
                        default:
                          break;
                      }
                      callback('Already used Company No.');
                    })
                    .finally(() => setFields([{ name: 'no', validating: false }]));
                } else {
                  callback('aaa');
                }
              },
            }),
          ]}
        >
          <Input />
        </Form.Item>
        <div className="flex">
          <Button htmlType="submit" type="primary">
            등록
          </Button>
        </div>
      </Form>
    </>
  );
};

export default CompanyRegistrationPage;
